<template>
  <el-form
    ref="form"
    :model="form"
    :rules="rules"
    :inline="true"
    label="left"
    label-width="60px"
    size="mini"
    @submit.prevent="onSubmit"
    style="margin:-5px;width:95%;width:1000px;"
  >
    <el-col :span="24" style="text-align:center">
      <el-form-item style="text-align:center;">
        <strong style="font-size: 20px">委托单</strong>
      </el-form-item>
    </el-col>
    <el-col :span="12" style="text-align:left ;">
      <el-form-item style="text-align:left ;margin:-5px;">
        <strong>委托方</strong>
      </el-form-item>
    </el-col>

    <el-col :span="12" style="text-align:right ;">
      <el-form-item style="margin:-5px;">
        <strong>编号</strong>
      </el-form-item>
    </el-col>
    <br />
    <el-form-item label="名称">
      <el-input v-model="form.clientName" style="width:410px" disabled></el-input>
    </el-form-item>
    <el-form-item label="联系人">
      <el-input v-model="form.clientContacts" style="width:170px" disabled></el-input>
    </el-form-item>
    <el-form-item label="电话">
      <el-input v-model="form.clientPhone" style="width:160px" disabled></el-input>
    </el-form-item>
      <el-form-item label="地址 " >
        <el-input v-model="form.clientAddr" style="width:410px" disabled></el-input>
      </el-form-item>
    <el-form-item label="邮箱" >
      <el-input v-model="form.clientMail" style="width:170px" disabled></el-input>
    </el-form-item>
    <el-form-item label="传真">
      <el-input v-model="form.clientFax" style="width:160px"></el-input>
    </el-form-item>
    <br />

    <el-form-item style="text-align:left;margin:-3px;">
      <strong>样品信息</strong>
    </el-form-item>
    <br />
    <el-form-item style="text-align:left;margin:-1px;">
      <el-button type="primary" @click="add()">新增</el-button>
    </el-form-item>
    <el-table :data="tableData1" stripe style="width: 97%" >
     <el-table-column label="序号"  width="100" type="index">
    </el-table-column>
      <el-table-column prop="name" label="样品名称" width="180"></el-table-column>
      <el-table-column prop="specs" label="型号规格"></el-table-column>
      <el-table-column prop="trademark" label="商标"></el-table-column>
      <el-table-column prop="number" label="数量"></el-table-column>
       <el-table-column label="操作" width="180">
        <template slot-scope="scope" >
          <el-button size="small" type="success" @click="edit(scope.$index,scope.row)">编辑</el-button>
          <el-button size="small" type="danger" @click="deleteRow(scope.$index, scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-form-item style="text-align:left;margin:-3px;">
      <strong>检验要求</strong>
    </el-form-item>
    <br />
    <el-form-item label="检验依据" label-width="78px" prop="basis">
      <el-input v-model="form.basis" style="width:270px"></el-input>
    </el-form-item>
    <el-form-item label="检验项目" label-width="78px" prop="items">
      <el-input v-model="form.items" style="width:270px"></el-input>
    </el-form-item>
    <br />
    <el-col :span="24">
      <el-form-item label="该检验是否与诉讼有关" label-width="160px">
        <el-radio v-model="form.lawsuit" label="1">否</el-radio>
        <el-radio v-model="form.lawsuit" label="2">是</el-radio>
      </el-form-item>
    </el-col>
    <br />
    <el-form-item style="text-align:left;margin:-3px;">
      <strong>报告要求</strong>
    </el-form-item>
    <br />
    <el-col :span="7">
      <el-form-item label="报告版本" label-width="70px">
        <el-checkbox-group v-model="form.reportType" @change="val => checkinlist(val)">
          <el-checkbox v-for="report in reportTypes" :label="report" :key="report">{{report}}</el-checkbox>
        </el-checkbox-group>
      </el-form-item>
    </el-col>
    <el-col :span="12">
      <el-form-item label="报告形式" label-width="70px">
        <el-checkbox-group v-model="form.reportForm" @change="val => checkinlist1(val)">
          <el-checkbox
            v-for="form1 in forms"
            :label="form1.value"
            :key="form1.value"
          >{{form1.label}}</el-checkbox>
        </el-checkbox-group>
      </el-form-item>
    </el-col>
    <!-- <el-col :span="7">
                 <el-form-item label="获取方式" label-width="70px">
                      <el-radio v-model="radio" label="1">自取</el-radio>
                 <el-radio v-model="radio" label="2">邮寄</el-radio>
                 </el-form-item>
            
    </el-col>-->
    <el-form-item label="如对报告有其他要求，请说明" label-width="195px">
      <el-input v-model="form.reportRemark" style="width:770px"></el-input>
    </el-form-item>
    <br />
    <el-form-item style="text-align:left;margin:-5px;">
      <strong>样品处理</strong>
    </el-form-item>
    <br />
    <el-col :span="7">
      <el-form-item>
        <el-radio v-model="form.sampleHandle" label="1">邮寄</el-radio>
        <el-radio v-model="form.sampleHandle" label="2">销毁</el-radio>
        <el-radio v-model="form.sampleHandle" label="3">自取</el-radio>
        <el-radio v-model="form.sampleHandle" label="4">保管</el-radio>
      </el-form-item>
    </el-col>
    <el-form-item label="被委托部门" v-if="false">
      <el-input v-model="form.clientDept" style="width:170px"></el-input>
    </el-form-item>
    <el-form-item label="下委托单人" v-if="false">
      <el-input v-model="form.userId" style="width:170px"></el-input>
    </el-form-item>
    <el-form-item label="下委托公司" v-if="false">
      <el-input v-model="form.enterpriseId" style="width:170px"></el-input>
    </el-form-item>
    <el-form-item label="外网委托标识" v-if="false">
      <el-input v-model="form.isextranet" style="width:170px"></el-input>
    </el-form-item>
    <el-col :span="24" style="text-align:center">
      <el-form-item>
        <el-button type="primary" @click="onSubmit('form')">确认下单</el-button>
      </el-form-item>
    </el-col>
    <el-dialog :title="formtitle" :visible.sync="dialogFormVisible">
      <el-form ref="subData" :model="obj" label-width="90px" @submit.prevent="onSubmit">
        <el-form-item label="样品名称">
          <el-input v-model="obj.name" placeholder="请输入样品名称"></el-input>
        </el-form-item>
        <el-form-item label="规格型号">
          <el-input v-model="obj.specs" placeholder="请输入规格型号"></el-input>
        </el-form-item>
        <el-form-item label="商标">
          <el-input v-model="obj.trademark" placeholder="请输入商标"></el-input>
        </el-form-item>

        <el-form-item label="数量">
          <el-input v-model="obj.number" placeholder="请输入数量"></el-input>
        </el-form-item>
      
        <!-- <el-form-item label="状态">
					<el-radio-group v-model="subData.state">
						<el-radio label="10">正常</el-radio>
						<el-radio label="20">禁用</el-radio>
					</el-radio-group>
        </el-form-item>-->
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align:center">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="open()">确 定</el-button>
      </div>
    </el-dialog>
  </el-form>
</template>

<script>
import { RequestPost, RequestGet } from "../../api/api";
import { url } from "../../api/api";
const reportTypesOptions = ["中文", "英文", "数据"];
const formOptions = [
  { value: "1", label: "电子版" },
  { value: "2", label: "纸质版(自取)" },
  { value: "3", label: "纸质版(快递)" }
];
export default {
  data() {
    return {
      form: {
        clientName: "",
        clientAddr: "",
        clientContacts: "",
        clientPhone: "",
        clientMail: "",
        clientFax: "",
        producerName: "",
        producerAddr: "",
        producerContacts: "",
        producerPhone: "",
        producerMail: "",
        producerFax: "",
        factoryName: "",
        factoryAddr: "",
        factoryContacts: "",
        factoryPhone: "",
        factoryMail: "",
        factoryFax: "",
        agentName: "",
        agentAddr: "",
        agentContacts: "",
        agentPhone: "",
        agentMail: "",
        agentFax: "",
        payerName: "",
        payerAddr: "",
        payerContacts: "",
        payerPhone: "",
        payerMail: "",
        payerFax: "",
        receiverName: "",
        receiverAddr: "",
        receiverContacts: "",
        receiverPhone: "",
        receiverMail: "",
        receiverFax: "",
        basis: "",
        items: "",
        lawsuit: "1",
        clientDept: "",
        reportType: ["中文"],
        reportForm: ["1"],
        reportRemark: "",
        sampleHandle: "1",
        subData: [],
        userId: "",
        enterpriseId: "",
        isextranet: "1"
      },
      rules: {
        basis: [
          {
            required: true, //是否必填
            message: "检验依据不能为空", //规则提示
            trigger: "blur" //何事件触发
          }
        ],
        items: [
          {
            required: true, //是否必填
            message: "检验项目不能为空", //规则提示
            trigger: "blur" //何事件触发
          }
        ]
      },
      checkedCities: [],
      reportTypes: reportTypesOptions,
      checkedForms: [],
      forms: formOptions,
      checkedWays: [],
      radio: "1",
      radio1: "1",
      lawsuit: "1",
      tableData: [],
      tableData1: [],
      obj: {},
      dialogFormVisible: false,
      formtitle: "",
      index:""
    };
  },
  methods: {
    onSubmit(form) {
      //console.log(this.form.reportForm);
      this.$refs[form].validate(valid => {
        if(valid){
           this.$confirm("确认下单, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "info"
        })
          .then(() => {
            RequestPost("/consignation/saveConsignation", this.form).then(
              response => {
                console.log(this.form);
                if (response.code == "0000") {
                  this.$message({
                    message: response.message,
                    type: "success"
                  });
                  清空表单;
                  this.form = {
                    clientName: "",
                    clientAddr: "",
                    clientContacts: "",
                    clientPhone: "",
                    clientMail: "",
                    clientFax: "",
                    basis: "",
                    items: "",
                    lawsuit: "",
                    reportType: [],
                    reportForm: "",
                    reportRemark: "",
                    sampleHandle: ""
                  };
                  清空表单;
                  this.$router.push({ path: "/consignationQuery" });
                } else {
                  this.$message({
                    message: response.message,
                    type: "error"
                  });
                }
              }
            );
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消"
            });
          });
        }
      });
    },
    add() {
      // this.form.subData = {};
      this.obj = {};
      this.dialogFormVisible = true;
      this.formtitle = "新增样品信息";
    }, 
    open() {
      //如果是新增往样品表里面加数据
      if(this.formtitle=="新增样品信息"){
      this.tableData1.push(this.obj);
      this.form.subData.push(this.obj);
      this.dialogFormVisible = false;
      }
      //如果是修改，则修改数据，不push
      if(this.formtitle=="修改样品信息"){
        this.tableData1[this.index].name=this.obj.name;
        this.tableData1[this.index].number=this.obj.number;
        this.tableData1[this.index].specs=this.obj.specs;
        this.tableData1[this.index].trademark=this.obj.trademark;

        this.form.subData[this.index].name=this.obj.name;
        this.form.subData[this.index].number=this.obj.number;
        this.form.subData[this.index].specs=this.obj.specs;
        this.form.subData[this.index].trademark=this.obj.trademark;
        //console.log(this.tableData1);
        //console.log( this.form.subData);
         this.dialogFormVisible = false;
      }
      
    },
    checkinlist(val) {
      // 获取报告版本
      this.reportType = val;
    },
    checkinlist1(val) {
      // 获取报告形式
      this.reportForm = val;
      console.log(this.reportForm);
    },
    getUserInfo() {
      var person = {
        id: sessionStorage.getItem("userId")
      };
      RequestGet("/customer/findByid", person).then(response => {
        //console.log(response);
        if (response.code == "0000") {
          this.form.clientName = response.data.enterpriseName;
          this.form.clientAddr = response.data.addr;
          this.form.clientContacts = response.data.name;
          this.form.clientMail = response.data.email;
          this.form.clientPhone = response.data.phone;
        } else {
        }
      });
    }, 
     edit(index, rows) {
      this.formtitle="修改样品信息";
      this.dialogFormVisible = true;
      this.obj = rows;
      this.index=index;
    },
     deleteRow(index, rows) {
      this.tableData1.splice(index,1);
      this.form.subData.splice(index,1);
        // console.log(this.tableData1);
        // console.log( this.form.subData);
    },
  },
  created: function() {
    this.form.clientDept = this.$route.query.depId;
    this.form.userId = sessionStorage.getItem("userId");
    this.form.enterpriseId = sessionStorage.getItem("enterpriseId");
    this.getUserInfo();
  }
};
</script>
<style>
.el-dialog--small {
  width: 30%;
}
.span {
  position: relative;
  padding: 8px;
}
.tip {
  display: block;
  background: #f00;
  border-radius: 50%;
  width: 8px;
  height: 8px;
  top: 12px;
  right: 0px;
  position: absolute;
}
</style>


// WEBPACK FOOTER //
// placeOrder.vue?419c0daa